import log from 'salvo-lite/log'

class Caption {
    constructor (theme, elem) {
        this._theme = theme
        this._elem = elem
        this._captions = this._elem.querySelectorAll('.caption')
        log.debug(this.constructor.name, 'Constructed', this)
    }
    onInit () {
        if (window.innerWidth < 769) {
            for (var c = 0; c < this._captions.length; c++) {
                const caption = this._captions[c]
                const captionHeight = caption.offsetHeight
                const titleHeight = caption.querySelector('.inner').firstElementChild.offsetHeight + 20
                const rteHeight = captionHeight - 40 - titleHeight
                const rte = caption.querySelector('.rte')
                rte.style.maxHeight = rteHeight + 'px'
            }
        }
    }
}

export default Caption



// WEBPACK FOOTER //
// ./src/resources/scripts/components/Caption.js